import React, { Component } from "react";

export default class About extends Component {
  render() {
    // const { getInterface } = this.props;
    return (
      <div className={`flex justify-center`}>
        <div className="w-full lg:w-7/12 p-4 lg:px-0 lg:py-4">
          <h3 className="text-3xl font-semibold mt-8">
            Tentang Nikola Arinanda
          </h3>
          <div className="width-full flex justify-center my-10">
            <img
              src={`${process.env.PUBLIC_URL}/images/archive/profile.png`}
              alt="Profile"
              className="w-72 h-72 rounded-full"
            ></img>
          </div>
          <p>
            Nikola Arinanda adalah seorang Full Stack Web Developer serta
            Blockchain dan AI Enthusiast yang saat ini sedang menempuh
            pendidikan di Institut Teknologi Sumatera. Sebelumnya, Ia telah
            magang di Gink Technology melanjutkan project website yang ada dan
            kemudian lanjut bekerja di Init Visual Experia (INVIX) membuat role
            MHO untuk website Halal Partner dari MUI. Nikola juga pernah
            terlibat mengembangkan website protype untuk Geopark Ekuator Pasaman
            dalam rangka kegiatan KKN serta menjadi peserta program BANGKIT
            Academy tahun 2024 dengan jalur Cloud Computing.
          </p>
          {/* <br />
          <p>
            Aspernatur eum commodi, expedita in placeat modi omnis sit soluta
            tempora. Eligendi necessitatibus consequatur aspernatur expedita
            ratione officiis consequuntur, nemo, incidunt veniam nostrum ut
            dicta reiciendis assumenda molestias corporis dolorum hic doloremque
            cumque id. Quod magni dolores facere, aut corporis quia molestias
            animi? Cupiditate a maiores et itaque magnam? Obcaecati iusto beatae
            tempore temporibus cum, accusantium recusandae ea nostrum dolorum
            molestiae fuga culpa alias et consequatur corporis unde placeat? Qui
            distinctio veritatis sit necessitatibus nemo expedita quod minima,
            aliquid animi eligendi unde atque quisquam reiciendis nisi magni
            tempore repellendus.
          </p> */}
        </div>
      </div>
    );
  }
}
